import { Row } from "@circle-react-uikit/SkeletonLoader/components/Row";

import { PriceBadge } from "../../../shared/PriceBadge";
import { previewPriceProperties } from "../../../shared/PriceBadge/constants";
import { usePricePreviewContext } from "../PricePreviewProvider";
import { TotalDueLine } from "./Lines/TotalDueLine";
import { ViewOrderDetailsLine } from "./Lines/ViewOrderDetailsLine";

export const MobileFixedOnTopPreview = Object.assign(
  () => {
    const { previewMutation } = usePricePreviewContext();
    const preview = previewMutation.data;

    return (
      <div className="bg-primary fixed z-10 flex w-full flex-row justify-between border-b px-5 py-4 md:hidden">
        <div className="flex flex-row items-baseline gap-x-2">
          <ViewOrderDetailsLine />
          {preview && (
            <PriceBadge properties={previewPriceProperties} preview={preview} />
          )}
        </div>
        <TotalDueLine.Value />
      </div>
    );
  },
  {
    Skeleton: () => (
      <div className="bg-primary fixed z-10 flex w-full flex-row justify-between border-b px-5 py-4 md:hidden">
        <div className="flex flex-row items-center gap-x-2">
          <Row />
        </div>
        <Row xl />
      </div>
    ),
  },
);
